import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDHsFantanResult implements ICommand
{

	public Remainder : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.Remainder = ba.readUint8();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint8(this.Remainder);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDHsFantanResult();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'Remainder(B)='+this.Remainder+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 0;
	}

	public getCmdName() : string
	{
		return 'HsFantanResult';
	}

}
